import{n as e}from"./icons-es.js";let n=[];Object.keys(e).forEach(o=>{n=n.concat(e[o])});function a(){return n}export{a as n};
//# sourceMappingURL=nebula-icon-names-es.js.map
